import { formatDateTime } from "..";

const dateColumn = (accessor, Header, timezone) => ({
  id: accessor,
  Header,
  showTimeZone: true,
  accessor,
  Cell: (prop) => formatDateTime(prop.value, undefined, false, timezone),
});

export default dateColumn;
